  import axios from "axios"
  import accessToken from "./jwt-token-access/accessToken"
  import * as url from "./url_helper"

  //pass new generated access token here
  const token = accessToken

  //apply base url for axios
  const API_URL = process.env.REACT_APP_API_BASE_URL;

  const axiosApi = axios.create({
    baseURL: API_URL,
    // headers: {
    //   "Access-Control-Allow-Origin": "*",
    //   "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
    //   "Access-Control-Allow-Headers": "Content-Type, Authorization",
    // },
  })

  axiosApi.defaults.headers.common["Authorization"] = token

  axiosApi.interceptors.response.use(
    response => response,
    error => Promise.reject(error)
  )

  export async function get(url, config = {}) {
    return await axiosApi.get(url, { ...config }).then(response => response.data)
  }

  export async function post(url, data, config = {}) {
    if (data instanceof FormData) {
      return axiosApi
        .post(url, data, { ...config })
        .then(response => response.data);
    }
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data);
  }

  // export async function post(url, data, config = {}) {
  //   const headers = {
  //     "Access-Control-Allow-Origin": "*",
  //     "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
  //     "Access-Control-Allow-Headers": "Content-Type, Authorization",
  //     ...config.headers, // Merge with existing headers
  //   };
  
  //   return axiosApi
  //     .post(url, data, { ...config, headers })
  //     .then(response => response.data)
  //     .catch(error => {
  //       console.error('API Post Error:', error);
  //       throw error;
  //     });
  // }
  

  export async function update(url, data, config = {}) {
    return axiosApi
      .put(url, { ...data }, { ...config })
      .then(response => response.data)
  }

  export async function del(url, config = {}) {
    return await axiosApi
      .delete(url, { ...config })
      .then(response => response.data)
  }
